(function () {
	'use strict';

	angular.module('angularTreeview')
		.controller('frontpageTreeview', treeViewController);

	treeViewController.$inject = ['$scope', '$http', '$state', '$uibModal', '$location', '$timeout', 'favoriteService',
		'treeNavigationService', 'documentService', 'pubSub', 'configService', 'browserService'];

	function treeViewController($scope, $http, $state, $uibModal, $location, $timeout, favoriteService,
		treeNavigationService, documentService, pubSub, configService, browserService) {
		$scope.showTreeFavorites = false;
		$scope.showTreeDocument = false;
		$scope.showTreeMyMostRead = false;
		$scope.showTreeMyLastVisited = false;
		$scope.showToggleSearchPanel = false;
		$scope.showTreeProcesses = false;
		$scope.enableProcessModule = configService.getBool(HandbookConfiguration.EnableProcess);
		$scope.documentList = {};
		$scope.favoritesList = {};
		$scope.myMostReadList = {};
		$scope.myLastVisitedList = {};
		$scope.showDocumentInTree = configService.getBool(HandbookConfiguration.ShowDocumentsInTree);

		var browserType = browserService.detectBrowserWindow();
		var previousRequest = { itemId: 0, itemType: '' };
		var initOpeningDocumentGroupAsDefault = false;
		var killProcessAreaRouteChanged = null;

		$scope.init = function () {
			openDefaultGroup();

			navigateToTreeMenuItem();
		};

		$scope.$on('$destroy', function () {
			killProcessAreaRouteChanged();
		});

		function openDefaultGroup() {
			//debugger;
			const groupToOpenAsDefault = parseInt(HandbookConfiguration.GroupToOpenAsDefault);
			if (groupToOpenAsDefault != GROUP_TO_OPEN_AS_DEFAULTS.NONE) {
				switch (groupToOpenAsDefault) {
					case GROUP_TO_OPEN_AS_DEFAULTS.DOCUMENT:
						initOpeningDocumentGroupAsDefault = true;
						$scope.loadWhenSelectMenu("Document");
						break;
					case GROUP_TO_OPEN_AS_DEFAULTS.PROCESS:
						$scope.loadWhenSelectMenu("Processes");
						break;
				}
				killProcessAreaRouteChanged = pubSub.subscribe(broadcastType.processAreaRouteChanged, processAreaRouteChanged);
			}
		}

		function navigateToTreeMenuItem() {
			//debugger;
			var urlParams = new URLSearchParams(window.location.search);
			var menuType = urlParams.get('treeMenu');
			switch (menuType) {
				case 'Favorites':
					$scope.loadWhenSelectMenu('Favorites');
					break;
				case 'MyLastVisited':
					$scope.loadWhenSelectMenu('MyLastVisited');
					break;
				default:
					break;
            }
			
		}

		$scope.clearSelect = function () {
			if (configService.getBool(HandbookConfiguration.IsAuthenticated) && !configService.getBool(HandbookConfiguration.IsAnonymous)) {
				if ($scope["favoritesTree"].currentNode) {
					var currentItem = getItemById($scope["favoritesTree"].currentNode.id, $scope.favoritesList);
					if (currentItem) {
						currentItem.selected = undefined;
					}
				}

				if ($scope["myMostReadTree"].currentNode && $scope["myMostReadTree"].currentNode.selected) {
					$scope["myMostReadTree"].currentNode.selected = undefined;
				}
				if ($scope["myLastVisitedTree"].currentNode && $scope["myLastVisitedTree"].currentNode.selected) {
					$scope["myLastVisitedTree"].currentNode.selected = undefined;
				}
			}

			if ($scope["documentTree"].currentNode && $scope["documentTree"].currentNode.selected) {
				$scope["documentTree"].currentNode.selected = undefined;
			}
		};

		$scope.selectNodeHead = function (node) {
			//debugger;
			//check if type of selected node is in [1, 2, 3, 4] = [Document, LinkDocument, FileDocument, ShortcutDocument] refer to enum NodeType, we dont call request
			if (!node.isLoaded && node.type > 4) {
				switch (node.TreeFlag) {
					case "Document":
						$http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': node.id, 'showDocumentInTree': $scope.showDocumentInTree } })
							.success(function (data, status, headers, config) {
								node.children = data.filter(x => !x.hidden);
								node.isLoaded = true;
								var isScroll = !$scope.showTreeFavorites && !$scope.showTreeMyMostRead && !$scope.showTreeMyLastVisited;
								treeNavigationService.onChildrenLoaded(node, isScroll);
							})
							.error(function (data, status, headers, config) {
								node.isLoaded = true;
							});
						break;
					case "Favorites":
						$http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': node.id, 'showDocumentInTree': $scope.showDocumentInTree} })
							.success(function (data, status, headers, config) {
								node.children = data.filter(x => !x.hidden);
								node.isLoaded = true;
							})
							.error(function (data, status, headers, config) {
								node.isLoaded = true;
							});
						break;
				}
			}
		};

		$scope.IsFolderNode = function (node) {
			return node.type == E.nodeTypes.Folder || node.type == E.nodeTypes.TopFolder || node.type == E.nodeTypes.DepartmentFolder || node.type == E.nodeTypes.RegionalFolder;
		}

        $scope.selectNodeLabel = function (node) {
			angular.element('.selected:not(#' + node.id + '-label)').removeClass('selected');
			$scope.clearSelect();
			if (node.isFavorited != undefined && node.isFavorited == true) {
				favoriteService.setFavoriteNodeState({ isFavorited: true, id: node.id, type: node.type });
			} else {
				favoriteService.setFavoriteNodeState({ isFavorited: false, id: node.id, type: node.type });
			}

			if (node.treeId == 'documentTree') {
				//If we click on document tree we don't call Autohighlight function
				treeNavigationService.setIsDocumentTree(true);
				//Need to set timeout for set item selected
				$timeout(function () {
					if ($scope.IsFolderNode(node)) {
						angular.element('#' + node.id + '-label-f').addClass('selected');
					} else {
						angular.element('#' + node.id + '-' + node.virtualHandbookId + '-label').addClass('selected');
					}
				});
			}
			if ($scope.IsFolderNode(node)) {
				$state.go(handbookActions.FolderAction, { folderId: node.id });
			} else {
				if (browserType == BrowserType.MOBILE) {
					$scope.$emit(broadcastType.hideSidebarInMobileWhenOpenDocument);
                }
				documentService.goToDocument(node.id, node.defaultFieldView);
			}
		};

		$scope.loadWhenSelectMenu = function (menuType) {
            $scope.showHideMenuLeft(menuType);
			switch (menuType) {
				case "Document":
					$scope.showTreeDocument = !$scope.showTreeDocument;
					if ($scope.showTreeDocument) {
						var node = angular.element('#treeDocuments .selected');
						if (node && node.length) {
							$timeout(function () {
								treeNavigationService.scrollToVisibleView(node);
							});
						}
					}
					if ($scope.showTreeDocument && $scope.documentList.length == undefined) {
						$http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': null, 'showDocumentInTree': $scope.showDocumentInTree} })
							.success(function (data, status, headers, config) {						
								$scope.documentList = data.filter(x => !x.hidden);
								treeNavigationService.navigateToItemLocation(true);
								if (parseInt(HandbookConfiguration.DocumentRootItemToExpand) !== NONE_DOCUMENT_ROOT_ITEM_TO_EXPAND
									&& initOpeningDocumentGroupAsDefault) {
									initOpeningDocumentGroupAsDefault = false;
									if ($scope.documentList && $scope.documentList.length > 0) {
										var node = null;
										const documentRootItemToExpandId = parseInt(HandbookConfiguration.DocumentRootItemToExpand);
										for (var i = 0; i < $scope.documentList.length; i++) {
											if ($scope.documentList[i].id == documentRootItemToExpandId) {
												node = $scope.documentList[i];
												break;
											}
										}
										if (node != null) {
											node.TreeFlag = "Document";
											node.collapsed = true;
											$scope.selectNodeHead(node);
										}
									}
								}
							});
					}
					break;
				case "Favorites":
					$scope.showTreeFavorites = !$scope.showTreeFavorites;
					if ($scope.showTreeFavorites && $scope.favoritesList.length == undefined) {
						//debugger;
						$http.get(handbookRequests.GetFavoritesRequest).
							success(function (data, status, headers, config) {
								getFavoritesData(data);
							});
						$scope.$broadcast("Favorites_GetProcessFavoritesList");
					}
					break;
				case "MyMostRead":
					//debugger;
					$scope.showTreeMyMostRead = !$scope.showTreeMyMostRead;
					if ($scope.showTreeMyMostRead && $scope.myMostReadList.length == undefined) {
						$http.get(handbookRequests.GetMostViewedDocumentsRequest).
							success(function (data, status, headers, config) {
								$scope.myMostReadList = data.filter(x => !x.hidden);
							});
					}
					break;
				case "MyLastVisited":
					//debugger;
					$scope.showTreeMyLastVisited = !$scope.showTreeMyLastVisited;
					if ($scope.showTreeMyLastVisited && $scope.myLastVisitedList.length == undefined) {
						$http.get(handbookRequests.GetRecentDocumentsRequest).
							success(function (data, status, headers, config) {
								$scope.myLastVisitedList = data.filter(x => !x.hidden);
							});
					}
					break;
				case "ToggleSearchPanel":
					//debugger;
					$scope.showToggleSearchPanel = true;
					break;
				case "Processes":
					//debugger;
					$scope.showTreeProcesses = !$scope.showTreeProcesses;
					$state.go('areas-root-view');
					break;
			}
		};

		$scope.showHideMenuLeft = function (menuType) {
			$scope.showTreeFavorites = (menuType != "Favorites") ? false : $scope.showTreeFavorites;
			$scope.showTreeMyMostRead = (menuType != "MyMostRead") ? false : $scope.showTreeMyMostRead;
			$scope.showTreeMyLastVisited = (menuType != "MyLastVisited") ? false : $scope.showTreeMyLastVisited;
			$scope.showTreeDocument = (menuType != "Document") ? false : $scope.showTreeDocument;
			$scope.showToggleSearchPanel = (menuType != "ToggleSearchPanel") ? false : $scope.showToggleSearchPanel;
			$scope.showTreeProcesses = (menuType != "Processes") ? false : $scope.showTreeProcesses;
		};

        $scope.$on(broadcastType.onTreeNavigation, function (e, target) {
			treeNavigationService.changeRoute();
			var element = $location.path().split('/');
			var requestParams = {
				itemId: element[2],
				itemType: element[1]
			};
			if (previousRequest.itemId == requestParams.itemId && requestParams.itemType == requestParams.itemType) {
				return;
			}
			previousRequest = angular.copy(requestParams);
			if (target.parents != null && target.parents.length) {
				navigateToCurrentItem(target.parents);
			}
		});

        $scope.$on(broadcastType.collapseExpandSidebar, function (e, target) {
			//Get flag to check user click on tree
			//If click on document tree we will not call Autohighlight 
			var isDocumentTree = treeNavigationService.getIsDocumentTree();
			if (target.navigateSideBar && !isDocumentTree) {
				treeNavigationService.changeRoute();
				navigateToCurrentItem(null);
			} else {
				treeNavigationService.setIsDocumentTree(false);
			}
		});

		$scope.$on(broadcastType.onOpeningSidebarMenu, function (e, target) {
			$scope.loadWhenSelectMenu(target.menu);
		});

		function processAreaRouteChanged(target) {
			if (!$scope.showTreeProcesses)
				$scope.showTreeProcesses = !$scope.showTreeProcesses;
		}

		function navigateToCurrentItem(parents) {
			if (!$scope.showTreeDocument) {
				if (!$scope.showTreeFavorites && !$scope.showTreeMyMostRead && !$scope.showTreeMyLastVisited) {
					$scope.showTreeDocument = true;
					$scope.showHideMenuLeft('Document');
				}
				if ($scope.documentList.length == undefined) {
					$http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': null, 'showDocumentInTree': $scope.showDocumentInTree } })
						.success(function (data, status, headers, config) {
							$scope.documentList = data.filter(x => !x.hidden);
							makeRecursiveParentRequest(parents);
						});
				} else {
					makeRecursiveParentRequest(parents);
				}
			} else {
				makeRecursiveParentRequest(parents);
			}
		};

        function makeRecursiveParentRequest(parents) {
			treeNavigationService.setDocumentsTree($scope["documentTree"]);
			var isScroll = !$scope.showTreeFavorites && !$scope.showTreeMyMostRead && !$scope.showTreeMyLastVisited;
			if (!parents || !parents.length) {
				var element = $location.path().split('/');
				if ($location.path().indexOf('process-fe/') >= 0) return;

				treeNavigationService.setNodeType($location.path().indexOf('document/') >= 0 ? treeNodeTypes.document : treeNodeTypes.folder);
				var requestParams = {
					itemId: element[2],
					itemType: element[1]
				};
				if (requestParams.itemId) {
					$http.get(handbookRequests.GetParentFoldersRequest, { params: requestParams })
						.then(function (response, status, headers, config) {
							var _parents = buildBreadcrumbs(response.data);
							treeNavigationService.navigateToCurrentItem($scope.documentList, _parents, isScroll);
						});
				}
			} else {
				treeNavigationService.navigateToCurrentItem($scope.documentList, parents, isScroll);
			}
        }

		function buildBreadcrumbs(data) {
			var result = [];
			var totalItem = data.length;

			//move root to result array
			for (var i = 0; i < data.length; i++) {
				if (data[i].parentFolderId == null) {
					result.push(data[i]);
					data.splice(i, 1);
					break;
				}
			}

			//fill in the rest
			var currentItem = 0;
			while (result.length != totalItem && currentItem <= result.length) {
				for (var i = 0; i < data.length; i++) {
					if (result[currentItem].id == data[i].parentFolderId) {
						result.push(data[i]);
						data.splice(i, 1);
						break;
					}
				}
				currentItem++;
			}

			return result;
		};

		$scope.popupModal = function () {
			var modalInstance = $uibModal.open({
				templateUrl: paths.ManageFavoritesView,
				controller: controllers.manageFavoritesController,
				size: 'lg',
				backdrop: 'static',
				resolve: {
					items: function () {
						var data = angular.copy($scope.favoritesList);
						return data;
					}
				}
			});

			modalInstance.result.then(function (items) {
				if (items != undefined) {
					$scope.favoritesList = items;
				}
			});
		};

		$scope.$on(broadcastType.documentOpenedTarget, function (e, target) {
			if ($scope.myLastVisitedList.length != undefined) {
				updateLastVisitedList(target);
			}
		});

		$scope.$on(broadcastType.favoriteTarget, function (e, target) {
			$scope.refreshFavorites();
		});

		function addOrRemoveFavoriteItem(target) {
			if (target.requestType == requestType.addRequest) {
				target.data.isFavorited = true;
				if (target.data.type > E.nodeTypes.ShortcutDocument) {
					var lastDocumentIndex = getLastFavoriteDocumentIndex();
					$scope.favoritesList.splice(lastDocumentIndex, 0, target.data);
				}
				else {
					$scope.favoritesList.splice(0, 0, target.data);
				}
			}
			else {
				if (target.data.isDocument) {
					removeDocumentInfavoritesList(target);
				} else {
					removeFolderInfavoritesList(target)
				}
				// Remove favorite state
				favoriteService.setFavoriteNodeState({
					isFavorited: false, id: target.data.id, type: 0
				});
			}
		}

		function removeFolderInfavoritesList(target) {
			for (var index = 0; index < $scope.favoritesList.length; index++) {
				if ($scope.favoritesList[index].id == target.data.id && $scope.IsFolderNode($scope.favoritesList[index])) {
					$scope.favoritesList.splice(index, 1);
					break;
				}
			}
		}

		function removeDocumentInfavoritesList(target) {
			for (var index = 0; index < $scope.favoritesList.length; index++) {
				if ($scope.favoritesList[index].id == target.data.id && isDocumentNode($scope.favoritesList[index].type)) {
					$scope.favoritesList.splice(index, 1);
					break;
				}
			}
		}

		function isDocumentNode(type) {
			return type == E.nodeTypes.Document || type == E.nodeTypes.LinkDocument || type == E.nodeTypes.FileDocument || type == E.nodeTypes.ShortcutDocument;
		}

		function getFavoritesData(data) {
			$scope.favoritesList = data.map(v => {
				v.isFavorited = true;
				return v;
			}).filter(x => !x.hidden);
		};

		function getLastFavoriteDocumentIndex() {
			var lastDocumentIndex = 0;
			for (var index = 0; index < $scope.favoritesList.length; index++) {
				if ($scope.favoritesList[index].type > E.nodeTypes.ShortcutDocument) {
					lastDocumentIndex = index;
					break;
				}
			}
			return lastDocumentIndex;
		}

		function updateLastVisitedList(target) {
			// Flag:  Check my last visited tree is selected
			var isSelectedTree = ($scope["myLastVisitedTree"].currentNode && $scope["myLastVisitedTree"].currentNode.selected);
			//Update  currentNode.selected = undefined if my last visited tree is selected
			if (isSelectedTree) {
				$scope["myLastVisitedTree"].currentNode.selected = undefined;
			}

			for (var index = 0; index < $scope.myLastVisitedList.length; index++) {
				if ($scope.myLastVisitedList[index].id == target.id) {
					$scope.myLastVisitedList.splice(index, 1);
					break;
				}
			}
			if ($scope.myLastVisitedList.length == HandbookConfiguration.RecentItemsCount) {
				$scope.myLastVisitedList.splice($scope.myLastVisitedList.length - 1, 1);
			}
			$scope.myLastVisitedList.splice(0, 0, target);
			//if my last visited tree is selected
			if (isSelectedTree) {
				$scope["myLastVisitedTree"].currentNode = $scope.myLastVisitedList[0];
				$scope["myLastVisitedTree"].currentNode.selected = cssClass.selected;
			}
		}

		function getItemById(id, source) {
			for (var index = 0; index < source.length; index++) {
				if (source[index].id == id) {
					return source[index];
					break;
				}
			}
			return null;
		}

		$scope.refreshFavorites = function () {
			//debugger;
			$http.get(handbookRequests.GetFavoritesRequest).
				success(function (data, status, headers, config) {
					getFavoritesData(data);
				});
			$scope.$broadcast("Favorites_GetProcessFavoritesList");
		}

		$scope.refreshDocument = function () {
			$http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': null, 'showDocumentInTree': $scope.showDocumentInTree } })
				.success(function (data, status, headers, config) {				
					$scope.documentList = data.filter(x => !x.hidden);
					treeNavigationService.navigateToItemLocation(true);
				});
		}

		$scope.goToProcessAreasRootView = function () {
			$state.go('areas-root-view');
		}
	};

})();

